import gql from 'graphql-tag'
import client from '../../stores/apollo'

interface IPayload {
  data: {
    canBook: boolean
  }
}

type ParamsT = { floorId: string; startDate: string; endDate?: string }

const getIsFloorBookable = ({ floorId, startDate, endDate }: ParamsT): Promise<boolean> => {
  const variables = { id: floorId, startDate, endDate }

  return client.gql
    .query({ query: isFloorBookableQuery, variables })
    .then(({ data: { canBook } }: IPayload) => canBook)
}

const isFloorBookableQuery = gql`
  query floorIsBookableQuery($id: ID!, $startDate: String!, $endDate: String) {
    node(id: $id) {
      ... on Floor {
        canBook(startDate: $startDate, endDate: $endDate)
      }
    }
  }
`

export default getIsFloorBookable
